import React from "react";
// Assuming these imports exist in your project
import { BulletPoints } from "./BulletPoints";
import { Invest } from "./Invest";

export const InvestCard1 = ({ plan, img }) => {
  return (
    <div className="group relative flex flex-col bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
      {/* 1. Image Header - Aspect Ratio 16:9 for consistency */}
      <div className="relative h-40 overflow-hidden">
        <img
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          src={img}
          alt={plan.planName}
        />
        {/* Overlay gradient for text readability if needed later */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      {/* 2. Card Body */}
      <div className="p-2 flex flex-col flex-grow">
        {/* Title and Badge Row */}
        <div className="flex justify-between items-start mb-3">
          <h2 className="text-lg font-bold text-slate-800 leading-tight">
            {plan.planName}
          </h2>
          <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-semibold rounded-md uppercase tracking-wide">
            {plan.duration}
          </span>
        </div>

        {/* Hero Metric: Profit */}
        <div className="mb-6">
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">
            Potential Return
          </p>
          <div className="flex items-baseline gap-1">
            <span className="text-3xl font-extrabold text-blue-600">
              {plan.profitProduction}%
            </span>
            <span className="text-sm text-gray-500 font-medium">ROI</span>
          </div>
        </div>

        {/* Min/Max Details - Styled as a clean list */}
        <div className="space-y-3 mb-2 bg-slate-50 p-3 rounded-lg border border-slate-100">
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Min Deposit</span>
            <span className="font-semibold text-slate-700">
              ${plan.minAmount}
            </span>
          </div>
          <div className="w-full h-px bg-gray-200"></div> {/* Divider */}
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Max Deposit</span>
            <span className="font-semibold text-slate-700">
              ${plan.maxAmount}
            </span>
          </div>
        </div>

        {/* 3. Button Section - Pushed to bottom with mt-auto */}
        <div className="mt-auto">
          {/* We wrap your existing button to ensure full width/styling control if needed */}
          <div className="w-full">
            <Invest fromWallet={false} />
          </div>
        </div>
      </div>
    </div>
  );
};
